
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AddNewItemCard extends Vue {
    @Prop() variant!: string;
}
